<template>
<div class="body_flow page">
    <div v-if="submitted" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <!-- Payment Error Toast -->
    <div v-if="paymentError" class="error-popup">
        <span>{{ errorMessage }}</span>
        <button class="error-popup-close" @click="paymentError = false">&times;</button>
    </div>

    <!-- Delivery Restriction Modal -->
    <div v-if="showOutOfStockModal" class="modal-overlay" @click="closeOutOfStockModal">
        <div class="modal-content out-of-stock-modal" @click.stop>
            <div class="intro-modal-body">
                <div class="intro-modal-heading">
                    <strong>{{ deliveryErrorMessage }}</strong>
                </div>
                <button class="modal-close-button" @click="closeOutOfStockModal">Close</button>
            </div>
        </div>
    </div>

    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="100vw" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el>2">
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651" style="margin-bottom: 3px;"></a>
                </div>
                <div class="mobile-nav-links">
                    <a :href="supportPhoneTel" class="link-block-109 w-inline-block"><img src="@/assets/images/icon_call_1.svg" loading="lazy" alt="" class="image-692"></a>
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()" v-if="active_el>2"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress" :style="{ width: Math.round((active_el / (totalSteps+1)) * 100) + '%' }"></div>
            </div>
        </div>
    </section>
    
    <section class="section_checkout-flow">
        <div class="flow_wrap">

            <div class="step4_div" v-if="active_el === 1">
                <div class="inclusions-new">
                    <div class="flow-inclusions-header">What's Included:</div>
                    <!--<div class="text-block-1713">The NewSelf Weight Loss Protocol is more than just medication, it is a full health optimization system to help you live better...longer.</div>-->
                    <div class="flow_inclusions-div">
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img :src="getMedicationDetails().image" loading="lazy" alt="" ></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">{{ getMedicationDetails().name }} <span style="color: #999;font-size: 14px;">{{ paymentInfo.payment_terms }} Month Supply</span></div>
                                    <p class="inclusions-subs">Personalized Compounded GLP&nbsp;Medication - Subcutaneous </p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="div-block-2249 top-float">
                                <div class="text-block-1711-copy"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalPrice(paymentInfo.payment_terms)) }}<span><sup class="superscript-11">{{ (getTotalPrice(paymentInfo.payment_terms) % 1).toFixed(2).split('.')[1] }}</sup></span></span><span class="text-span-420"> one time</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/icon_stetoscope.webp" loading="lazy" alt="" class="image-681"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Doctor Review</div>
                                    <p class="inclusions-subs">A doctor will review your intake, and prescribe (if appropriate) today! </p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <!--<div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/icon_discount.webp" loading="lazy" alt="" class="image-682"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Discounted Therapies</div>
                                    <p class="inclusions-subs">Accelerate your results and reduce side effects with additional treatment plans.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>-->
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/WeightSteps_Plan2.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/WeightSteps_Plan2-p-500.webp 500w, @/assets/images/WeightSteps_Plan2-p-800.webp 800w, @/assets/images/WeightSteps_Plan2.webp 1080w" alt="" class="image-684"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Metabolic Weight Plan</div>
                                    <p class="inclusions-subs">A Personalized weight loss plan to help you lose weight faster and keep it off. </p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/icon_van.webp" loading="lazy" alt="" class="image-683"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Overnight Cold Shipping</div>
                                    <p class="inclusions-subs">We ship all medications <strong>next-day on cold packs</strong> to keep them stable and effective.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/Doctor_newself.webp" loading="lazy" sizes="(max-width: 755px) 100vw, 755px" srcset="@/assets/images/Doctor_newself-p-500.webp 500w, @/assets/images/Doctor_newself.webp 755w" alt="" class="image-694"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Ongoing Doctor Support</div>
                                    <p class="inclusions-subs">Our doctors provide ongoing support and quarterly checkins to monitor your progress.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                    </div>
                    <div class="format-divider"></div>
                    <div class="div-block-2248 total">
                        <div class="text-block-1712">Total</div>
                        <div class="div-block-2249">
                            <div class="div-block-2250"><img src="@/assets/images/icon_tag.svg" loading="lazy" alt="" class="image-688">
                                <div class="text-block-1722">Summer Sale</div>
                            </div>

                            <div class="text-block-1711-copy"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalPrice(paymentInfo.payment_terms)) }}<span><sup class="superscript-11">{{ (getTotalPrice(paymentInfo.payment_terms) % 1).toFixed(2).split('.')[1] }}</sup></span></span><span class="text-span-420"> one time</span></div>
                        </div>
                    </div>
                    <div class="flow-ctrls-div continue-everything" style="justify-content: center;">
                        <a href="#" class="continue-button step w-button" style="width: 100%;" @click.prevent="active_el++">Continue <span class="text-span-423">-&gt;</span></a>
                    </div>
                    <div class="trust-pilot-div">
                        <a href="https://www.trustpilot.com/review/newself.com" target="_blank" class="no-decoration">
                        <img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-689">
                        <div class="flow-rating-div">
                            <div class="text-block-1723">Excellent</div>
                            <div class="text-block-1724">4.6 out of 5</div><img src="@/assets/images/Trustpilot_Logo_2022.svg.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/Trustpilot_Logo_2022.svg-p-500.webp 500w, @/assets/images/Trustpilot_Logo_2022.svg-p-800.webp 800w, @/assets/images/Trustpilot_Logo_2022.svg-p-1080.webp 1080w, @/assets/images/Trustpilot_Logo_2022.svg.webp 2560w" alt="" class="image-690">
                        </div>
                        <div>Trusted by thousands of members</div>
                        </a>
                    </div>

                </div>
            </div>

            <div class="step5_div" v-if="active_el === 2">
                <!-- Loading Overlay -->
                <div v-if="submitted" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Complete your order</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>

                <div class="flow_step5-choiceflex-div">
                    <!-- Payment Plan Selection -->
                    <div class="flow-payplan-div">
                        <div class="checkout-form w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                <div class="flow_payplan_select">

                                    <!-- Selected Medication Display -->
                                    <div class="order-item-flex">
                                        <div class="div-block-2241">
                                            <div class="product-box-flex">
                                                <div class="product-name-and-sub">
                                                    <div class="text-block-1690">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}<span class="text-span-422">+</span></div>
                                                    <div class="text-block-1691">COMPOUNDED W/ {{ selectedMedication === 'semaglutide' ? 'B12' : 'B6' }}</div>
                                                </div>
                                                
                                            </div>
                                            <div class="text-block-1693">All Dosages are same price. Meet w/ provider to personalize plan.</div>
                                        </div>
                                        <div class="order_img_div">
                                            <img :src="selectedMedication === 'semaglutide' ? '/images/Semaglutide-Vial_1.webp' : '/images/Tirzepatide-Vial_1.webp'" />

                                        </div>
                                    </div>

                                    <!-- Selected term from URL (shown first) -->
                                    <label v-for="term in orderedTerms" :key="term" class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===term}" @click="changePaymentTerms(term)">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===term}"></div>
                                        <input type="radio" v-model="paymentInfo.payment_terms" :value="term" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                        <span class="checkout-checkbox-text w-form-label">
                                            <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(term)) }}</strong><span class="text-span-416"><strong><sup>{{ (getTotalPrice(term) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                            <span class="text-span-417"> {{ getSelectedTermLabel(term) }}</span><br>
                                        </span>
                                        <div class="div-block-2242">
                                            <div class="text-block-1694">{{ getSelectedTermRightLabel(term) }}</div>
                                        </div>
                                    </label>

                                    <div class="text-block-1697">Sign up for other options and save.</div>
                                    <div class="plans-div">
                                        <!-- All other terms -->
                                        <label v-for="term in otherTerms" :key="term" class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===term}" @click="changePaymentTerms(term)">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===term}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="term" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTermMonthlyPrice(term)) }}</strong><span class="text-span-416"><strong><sup>{{ (getTermMonthlyPrice(term) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                                <span class="text-span-417" v-html="getTermLabel(term)"> </span><br><span class="tosspan" v-if="term==1">*3 month supply paid monthly. No credit checks or financing charges.</span>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">{{ getTermSubLabel(term) }}</span></div>
                                            </div>
                                            
                                        </label>
                                    </div>
                                    
                                </div>
                            </form>
                        </div>
                        <div class="flow-ctrls-div" style="justify-content: center;">
                            <a href="#" class="continue-button step w-button" style="width: 100%;" @click.prevent="continueFromStep17">Continue <span class="text-span-423">-&gt;</span></a>
                        </div>
                        <p style="font-size: 8px;line-height: 10px;padding-top: 13px;" v-if="paymentInfo.payment_terms===6 || paymentInfo.payment_terms==12"><sup>*</sup>Enjoy hassle-free delivery of your 3-month supply every 90 days. A brief 5-minute clinician check-in ensures everything stays on track, with medications dispensed in fresh 90-day quantities for safety and effectiveness.</p>
                    </div>

                    <div class="flow-pay-summary hide-in-mobile">
                        <div class="checkout-form w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="17a32de0-f4b2-ba0e-e661-91591044c4c7" aria-label="Email Form">
                                <div class="flow-sum-maindiv">
                                    <div class="flow-summary-top">
                                        <div class="text-block-1688-copy">Order Summary</div>
                                    </div>
                                    <div class="flow-sum-orders-div">
                                        <div class="order-line-div">
                                            <div class="order-name">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                            <div class="div-block-2243">
                                                <div class="order-price"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order-total-div">
                                        <div class="text-block-1698">Due today</div>
                                        <div class="div-block-2243">
                                            <div class="order-price-total"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9-copy">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                        </div>
                                    </div>
                                    <div class="flow-sum-guarantee-div">
                                        <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you're not eligible, we'll issue a full refund</p>
                                    </div>
                                </div>
                            </form>
                            <div class="w-form-done" tabindex="-1" role="region" aria-label="Email Form success">
                                <div>Thank you! Your submission has been received!</div>
                            </div>
                            <div class="w-form-fail" tabindex="-1" role="region" aria-label="Email Form failure">
                                <div>Oops! Something went wrong while submitting the form.</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="step6_div" v-if="active_el === 3">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Payment details</div>

                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step3-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="5e212543-757c-9c76-d0d5-ebcebbfcc5e5">
                            <div class="flow-payment-div" :class="{'dropdown-expanded': summeryOpen}">
                                <div data-hover="false" data-delay="0" class="flow-dropdown-sum w-dropdown" :class="{'w--open' : summeryOpen}" @click.prevent="summeryOpen = !summeryOpen">
                                    <div class="flow-sum-droptoggle w-dropdown-toggle" :class="{'w--open' : summeryOpen}" @click.prevent="summeryOpen = !summeryOpen">
                                        <div class="icon-49 w-icon-dropdown-toggle"></div>
                                        <div class="drop-sum-label-div div-block-2244">
                                            <div class="text-block-1701">Due Today </div>
                                            <div class="text-block-1701"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<span class="text-span-418"><sup>{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span></span></div>
                                        </div>
                                    </div>
                                    <div class="dropdown-list-18 w-dropdown-list" :class="{'w--open' : summeryOpen}">
                                        <div class="flow-sum-maindiv">
                                            <div class="flow-summary-top">
                                                <div class="text-block-1688-copy">Order Summary</div>
                                            </div>
                                            <div class="flow-sum-orders-div">
                                                <div class="order-line-div">
                                                    <div class="order-name">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}<br></div>
                                                    <div class="div-block-2243">
                                                        <div class="order-price"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="order-total-div">
                                                <div class="text-block-1698">Due today</div>
                                                <div class="div-block-2243">
                                                    <div class="order-price-total"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<sup class="superscript-9-copy">{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1705">What&#x27;s included</div>
                                            <div class="inclusions-new">
                                                <div class="flow_inclusions-div">
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img :src="selectedMedication === 'semaglutide' ? '/images/Semaglutide-Vial_1.webp' : '/images/Tirzepatide-Vial_1.webp'" loading="lazy" alt="" class="image-681"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                                                <p class="inclusions-subs" v-if="paymentInfo.payment_terms===12">3 Vials Every 90 Days for a Year.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===6">3 month supply now, 3 more in 90 days.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===3">3 month supply.</p>
                                                                <p class="inclusions-subs" v-else>3 Month Supply Paid Monthly</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img src="@/assets/images/icon_stetoscope.webp" loading="lazy" alt="" class="image-681"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Doctor Consult &amp; Support</div>
                                                                <p class="inclusions-subs">Provider support, 1:1 medical support and written prescription.</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                   
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img src="@/assets/images/icon_van.webp" loading="lazy" alt="" class="image-683"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Express Shipping</div>
                                                                <p class="inclusions-subs">We ship all medications next-day on cold packs.</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="div-block-2248">
                                                    <div class="text-block-1712">Total</div>
                                                    <div class="div-block-2249">
                                                        <div class="text-block-1711"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<span><sup class="superscript-11">{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span></span></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flow-sum-guarantee-div">
                                                <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you&#x27;re not eligible, we&#x27;ll issue a full refund</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Price breakdown. Visible without expanding the Due Today
                                     dropdown so the sub-price is never a surprise. Subtotal is
                                     gross and the Discount row is the exact difference, so the
                                     rows always sum to Total. -->
                                <div class="ft-sum-breakdown">
                                    <div class="ft-sum-row">
                                        <span class="ft-sum-label">Shipping</span>
                                        <span class="ft-sum-value">FREE</span>
                                    </div>
                                    <div class="ft-sum-row">
                                        <span class="ft-sum-label">Subtotal</span>
                                        <span class="ft-sum-value" :class="{ 'price-loading': !pricesReady }">${{ formatPrice(getCurrentPrice()) }}</span>
                                    </div>
                                    <div class="ft-sum-row" v-if="summaryDiscount > 0">
                                        <span class="ft-sum-label">Discount</span>
                                        <span class="ft-sum-value">-${{ formatPrice(summaryDiscount) }}</span>
                                    </div>
                                    <div class="ft-sum-row ft-sum-total">
                                        <span class="ft-sum-label">Total</span>
                                        <span class="ft-sum-value" :class="{ 'price-loading': !pricesReady }">${{ formatPrice(displayTotal) }}</span>
                                    </div>
                                </div>

                                <div class="form-field-label">Coupon Code</div>
                                <div class="div-block-2246">
                                    <input class="text-field-68 w-input" maxlength="256" :class="{'field-error' : couponError}" name="field" data-name="Field" v-model="paymentInfo.couponCode" placeholder="Optional Coupon Code" type="text" id="field" :disabled="couponApplied">
                                    <a href="#" @click.prevent="handleCouponSubmit" class="button-172 w-button" :class="{'disabled': couponApplied}">{{ couponApplied ? 'Applied' : 'Apply' }}</a>
                                </div>

                                <div class="text-block-1704">Payment Method</div>

                                <!-- Express Checkout + Card via Payment Element -->
                                <div class="express-checkout-section">
                                  <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }">
                                    <express-checkout-button
                                        :amount="walletSheetAmountInCents"
                                        @token="handleExpressPayment"
                                        @can-make-payment="canMakeExpressCheckout = $event"
                                    />
                                    <button v-if="paymentInfo.payment_terms !== 1" type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                        <span class="klarna-btn-text">Buy now, pay later with</span>
                                        <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                    </button>
                                  </div>
                                  <div class="pe-divider">
                                    <div class="pe-divider-line"></div>
                                    <span>OR</span>
                                    <div class="pe-divider-line"></div>
                                  </div>
                                </div>

                                
                                <div class="flow-form-full-div" style="margin-bottom: 15px;">
                                    <label class="pe-label-7x" for="full-name">Name on card*</label><input class="checkout-flow-input w-input" maxlength="256" name="full-name" data-name="full name" placeholder="Name on card" type="text" id="full-name" required="" v-model="fullName" @input="validateFullName" @blur="validateFullName" :class="{ 'field-error': fieldErrors.full_name }">
                                </div>
                                <div class="flow-form-full-div" style="margin-bottom: 15px;">
                                    <label class="pe-label-7x" for="email">Email*</label><input class="checkout-flow-input w-input" maxlength="256" name="email" data-name="email" placeholder="Email address" type="email" id="email" required="" v-model="paymentInfo.email" @input="validateEmail" @blur="validateEmail" :class="{ 'field-error': fieldErrors.email }">
                                </div>

                                <stripe-payment-element
                                    ref="stripePayment"
                                    :base-url="baseUrl"
                                    :user-id="user?.id"
                                    :user-name="fullName"
                                    :user-email="paymentInfo.email"
                                    :hide-address-fields="true"
                                    :billing-address="customerInfo"
                                    @ready="hasCardInput = $event"
                                    @error="handlePaymentError"
                                    @token="handlePaymentToken"
                                />

                                <label class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                                <div :class="{ 'address-highlight': addressBlink }">
                                    <google-places-autocomplete-new :api-key="googleMapsApiKey" @address-updated="getAddressData" border-color="var(--ce-grey)" />
                                </div>

                                <!-- Payment Error Display -->
                                <div v-if="paymentError" class="w-form-fail" style="display:block; margin-top: 15px; margin-bottom: 15px;">
                                    <div>{{ errorMessage }}</div>
                                </div>

                                <div class="div-block-2247">
                                    <button type="button" @click.prevent="getStripeToken" :disabled="submitted" class="pay-button w-button">
                                        {{ submitted ? 'Processing...' : 'Pay' }}
                                    </button>
                                    <p class="paragraph-185-copy">
                                        By clicking "Pay Now" you agree to enroll in a {{ paymentInfo.payment_terms }}-month program{{ paymentInfo.payment_terms > 1 ? ' billed upfront' : ' billed monthly' }}. You authorize payments and confirm that you have read and agree to the
                                        <a href="https://newself.com/returns-and-refund" target="_blank">Refund Policy</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms and Conditions</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms of Use</a>,
                                        <a href="https://newself.com/privacy-policy" target="_blank">Privacy Policy</a>,
                                        <a href="https://newself.com/hipaa" target="_blank">HIPAA Notice</a>, and
                                        <a href="https://newself.com/telehealth-consent" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                    </p>
                                </div>
                            </div>
                        </form>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Priority Physician Review — offered once the order is captured, never before -->
    <fast-track-upsell-modal
        v-if="fastTrackOffer"
        :addon="fastTrackAddon"
        :payment-method="fastTrackOffer.paymentMethod"
        :context="fastTrackOffer"
        @shown="onFastTrackShown"
        @purchased="onFastTrackPurchased"
        @done="onFastTrackDone"
    />
</div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js"
let stripe = null;
import GooglePlacesAutocompleteNew from '../common/GooglePlacesAutocomplete_new.vue'
import StripePaymentElement from '../common/StripePaymentElement.vue'
import ExpressCheckoutButton from '../common/ExpressCheckoutButton.vue'
import fastTrackUpsell from '@/mixins/fastTrackUpsell.js'
import { stashKlarnaPurchase } from '@/utils/klarnaPurchaseTracking.js'
import {
    mapGetters
} from 'vuex'
import {
    getProductByIdAsync
} from '@/utils/productData'

export default {
    name: 'WeightLossCheckoutFlow',
    components: {
        GooglePlacesAutocompleteNew,
        StripePaymentElement,
        ExpressCheckoutButton
    },
    mixins: [fastTrackUpsell],
    // add_to_cart 1, purchase 2 — the add-on's own purchase continues the count.
    fastTrackFunnelStep: 3,
    fastTrackForm: "deals",
    props: ['baseUrl', 'googleMapsApiKey'],
    data() {
        return {
            active_el: 1,
            totalSteps: 3,
            fieldErrors: {
                full_name: false,
                email: false
            },
            errorMessage: '',
            summeryOpen: false,
            // Payment-related data
            hasCardInput: false,
            submitted: false,
            correlationId: null,
            paymentError: false,
            selectedMedication: '',
            selectedDosage: '',
            paymentAttempts: 0,
            maxPaymentAttempts: 3,
            couponError: false,
            couponApplied: false,
            currentMedicationType: '',
            showOutOfStockModal: false,
            deliveryErrorMessage: '',
            fullName: "",
            ip_address: '',
            localCartItems: [],
            cachedOrderedTerms: null,
            cachedOtherTerms: null,
            addressBlink: false,
            canMakeExpressCheckout: false,

            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                first_name: "",
                last_name: "",
                email: "",
                payment_terms: 3,
                user_id: '',
                cardToken: '',
                cardBrand: '',
                amount: 499,
                discount: 0,
                medication: '',
                couponCode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                cardDetails: [],
                planId: '',
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
            },
            // ========================================
            // CONFIGURE PRICING FOR EACH TERM HERE
            // Format: {"medication": {"term": totalPrice}}
            // Example: {"semaglutide": {"1": 194.97, "3": 449.91, "6": 749.82, "12": 1199.64}}
            // Terms must match those in availableTerms() computed property
            // ========================================
            pricingConfig: JSON.parse('{"semaglutide":{"1": 194.97, "3":449.91,"6":749.82,"12":1199.64},"tirzepatide":{"1": 274.97, "3":644.91,"6":1169.82,"12":2099.64}}'),
            // Live plans from /api/get-all-plans keyed by payment_terms: { id, price }.
            // Empty until loadPlans resolves; on fetch failure it stays empty so pricing
            // falls back to pricingConfig and planId falls back to paymentInfo.planId.
            apiPlans: {},
            // The term add_to_cart last reported. A plan tile is a <label> wrapping its
            // radio, so one shopper click reaches changePaymentTerms twice and would
            // otherwise send the same event twice, one millisecond apart.
            lastTrackedTerm: null,
            // Gates the price display until the live plan fetch settles, so the env
            // fallback price never flashes on screen before the real one loads.
            pricesReady: false,
            paymentTermLabels: {
                1: {
                    planName: "Monthly Plan",
                    duration: "monthly",
                    billingFrequency: "monthly",
                    billingLabel: "Billed Monthly",
                    supplyDuration: "Monthly"
                },
                3: {
                    planName: "Quarterly Plan",
                    duration: "3-month",
                    billingFrequency: "quarterly",
                    billingLabel: "Billed Quarterly",
                    supplyDuration: "3 Month"
                },
                6: {
                    planName: "Half yearly Plan",
                    duration: "6-month",
                    billingFrequency: "every 6 months",
                    billingLabel: "Billed Every 6 Months",
                    supplyDuration: "6 Month"
                },
                12: {
                    planName: "yearly Plan",
                    duration: "12-month",
                    billingFrequency: "annually",
                    billingLabel: "Billed Annually",
                    supplyDuration: "12 Month"
                }
            }
        }
    },
    async mounted() {
        window.addEventListener('pageshow', this.handlePageShow);
        this.setSelectedMeds();
        // Cache the selected term and other terms based on initial selection
        const allTerms = [3, 6, 12];
        const selected = this.paymentInfo.payment_terms;
        const others = allTerms.filter(term => term !== selected);

        this.cachedOtherTerms = others;
        this.cachedOrderedTerms = [selected];

        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
        await this.initStripe();
        this.prefillFromUserData();
    },
    computed: {
        ...mapGetters(['user', 'isAuthenticated']),

        cartItems() {
            // Return local cart items for this page only
            return this.localCartItems;
        },

        cartTotal() {
            return this.localCartItems.reduce((total, item) => {
                const price = parseFloat(item.price.toString());
                return total + (price * item.quantity);
            }, 0);
        },

        cartTotalNoDiscount() {
            return this.localCartItems.reduce((total, item) => {
                const price = parseFloat(item.retail_price.toString());
                return total + (price * item.quantity);
            }, 0);
        },

        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },

        // Payment-related computed properties
        amountInCents() {
            return Math.round(this.getTotalOrderAmount() * 100);
        },

        // What the Apple/Google Pay sheet shows. Display only: the express element is
        // created with paymentMethodCreation:'manual', so it tokenizes and never charges.
        // amountInCents is already net of any coupon here (getTotalOrderAmount subtracts it).
        walletSheetAmountInCents() {
            return this.amountInCents;
        },
        // What the customer sees as their total.
        displayTotal() {
            return parseFloat(this.getTotalOrderAmount().toFixed(2));
        },
        // Discount actually applied, taken as the difference rather than from
        // paymentInfo.discount — getTotalOrderAmount clamps at 0, so a coupon larger
        // than the plan price would otherwise make the summary rows disagree.
        summaryDiscount() {
            return parseFloat((this.getCurrentPrice() - this.getTotalOrderAmount()).toFixed(2));
        },

        selectedPlanId() {
            // Plan ObjectId for the selected term (backend charges the plan price off this)
            const plan = this.apiPlans[this.paymentInfo.payment_terms];
            return plan ? plan.id : this.paymentInfo.planId;
        },

        getProductPricingData() {
            return this.selectedMedication === 'semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
        },


        availableTerms() {
            // ========================================
            // CONFIGURE AVAILABLE PAYMENT TERMS HERE
            // Add or remove terms as needed (e.g., [1, 3, 6, 12])
            // Make sure corresponding prices exist in pricingConfig
            // ========================================
            return [3, 6, 12];
        },

        selectedTerm() {
            return this.paymentInfo.payment_terms;
        },

        orderedTerms() {
            // Return cached order if it exists
            if (this.cachedOrderedTerms) {
                return this.cachedOrderedTerms;
            }
            return [];
        },

        otherTerms() {
            // Return cached other terms if they exist
            if (this.cachedOtherTerms) {
                return this.cachedOtherTerms;
            }
            return [];
        }
    },
    methods: {
        async handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
                await this.initStripe();
                if (this.$refs.stripePayment) {
                    this.$refs.stripePayment.resetElement();
                }
            }
        },

        async setSelectedMeds() {
            this.selectedMedication = this.$route.params.name.toLowerCase();
            this.paymentInfo.payment_terms = parseInt(this.$route.params.terms);
            let productId = this.$route.params.name === 'tirzepatide' ?
                '675ac4cb6bf102c19ec3afe9' :
                '675ac4cb6bf102c19ec3afec';

            try {
                // Async fetch (not the sync cache read) so a cold products cache on
                // this single-page checkout still returns the product -> cart + plan
                // build and loadPlans() runs (otherwise planId stays '').
                let product = await getProductByIdAsync(productId);
                let plan = product[0];
                const cartItem = {
                    id: plan.id,
                    name: plan.name,
                    category: plan.category.primary,
                    price: plan.pricing.retail_price,
                    retail_price: plan.pricing.retail_price,
                    subheader: 'Compound Medication',
                    sku: plan.sku,
                    stripe_id: plan.stripe_id,
                    quantity: 1,
                    image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                    is_addon: false,
                };

                // Set local cart items for this page only
                this.localCartItems = [cartItem];

                // Load live plan prices + plan ids for the selected product
                await this.loadPlans();

                // This page IS the whole funnel — there is no questionnaire in front of
                // it — so its numbering starts here. Step 1 add_to_cart, step 2 purchase.
                this.fireAddToCart(cartItem);

            } catch (error) {
                console.error('Error creating cart:', error);
                this.showError('Error adding item to cart. Please try again.');
                this.isLoading = false;
            } finally {
                // Reveal prices once the live fetch settles (success or failure) so the
                // skeleton never sticks; on failure the display falls back to pricingConfig.
                this.pricesReady = true;
            }
        },

        closeOutOfStockModal() {
            this.showOutOfStockModal = false;
            this.deliveryErrorMessage = '';
            this.currentMedicationType = '';
        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },

        isValidName(name) {
            if (!name || name.trim().length < 2) {
                return false;
            }
            const nameRegex = /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF\s'-]+$/;
            return nameRegex.test(name.trim());
        },

        splitFullName(fullName) {
            const trimmedName = fullName.trim();
            const parts = trimmedName.split(/\s+/);

            if (parts.length === 0) {
                return {
                    firstName: '',
                    lastName: ''
                };
            } else if (parts.length === 1) {
                return {
                    firstName: parts[0],
                    lastName: parts[0]
                };
            } else {
                const firstName = parts[0];
                const lastName = parts.slice(1).join(' ');
                return {
                    firstName,
                    lastName
                };
            }
        },

        validateFullName() {
            if (this.fullName && this.fullName.trim()) {
                if (!this.isValidName(this.fullName)) {
                    this.fieldErrors.full_name = true;
                } else {
                    this.fieldErrors.full_name = false;
                    const {
                        firstName,
                        lastName
                    } = this.splitFullName(this.fullName);
                    this.paymentInfo.first_name = firstName;
                    this.paymentInfo.last_name = lastName;
                }
            }
        },

        isValidEmail(email) {
            if (!email || !email.trim()) {
                return false;
            }
            // Regex that requires a valid email with TLD
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email.trim());
        },

        validateEmail() {
            if (this.paymentInfo.email && this.paymentInfo.email.trim()) {
                // Normalize email: trim and convert to lowercase
                this.paymentInfo.email = this.paymentInfo.email.trim().toLowerCase();

                if (!this.isValidEmail(this.paymentInfo.email)) {
                    this.fieldErrors.email = true;
                } else {
                    this.fieldErrors.email = false;
                }
            }
        },

        async updateAddress() {
            try {
                this.customerInfo.id = this.user.id;
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                throw new Error('Failed to update address');
            }
        },

        async registerUser() {
            try {
                // Check if user is already authenticated
                if (this.$store.getters.isAuthenticated) {
                    this.paymentInfo.user_id = this.user.id;
                    return true;
                }

                // Ensure email is normalized (trim and lowercase)
                const normalizedEmail = this.paymentInfo.email.trim().toLowerCase();

                const userPayload = {
                    first_name: this.paymentInfo.first_name,
                    last_name: this.paymentInfo.last_name,
                    email: normalizedEmail,
                    user_type: 'checkout',
                    source_web: 2,
                    ip_address: this.ip_address
                };

                const response = await this.$axios.post(`${this.baseUrl}/api/register-user`, userPayload);
                if (response.data.status === 'success') {
                    this.paymentInfo.user_id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);

                    // Save shipping address after user is created
                    await this.updateAddress();

                    return true;
                } else if (response.data.status === 'error' && response.data.message === 'Existing user found.') {
                    this.paymentError = true;
                    this.errorMessage = 'An account with this email already exists. Please login.';
                    this.submitted = false;
                    return false;
                }
            } catch (error) {
                console.error('Error during registration:', error);
                this.paymentError = true;
                this.errorMessage = 'An error occurred during registration. Please try again.';
                this.submitted = false;
                return false;
            }
        },
        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.paymentInfo.couponCode) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            await this.validateCoupon();
        },
        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    if (response.data.c_type === 2) {
                        const planAmount = this.getTotalOrderAmount();
                        const discountPercentage = response.data.c_val;
                        this.paymentInfo.discount = parseFloat(((planAmount * discountPercentage) / 100).toFixed(2));
                    } else {
                        this.paymentInfo.discount = response.data.c_val;
                    }
                } else {
                    this.couponError = true;
                }
            } catch (error) {
                this.couponError = true;
            }
        },

        clearFieldError(field) {
            if (this.fieldErrors[field]) {
                this.$set(this.fieldErrors, field, false);
            }
        },

        GoBack() {
            if (this.active_el > 2) {
                this.active_el--;
                this.fieldErrors = {};
            }
        },
        async initStripe() {
            try {
                stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
            } catch (error) {
                console.error('Failed to initialize Stripe:', error);
            }
        },

        handlePaymentError(message) {
            this.paymentError = true;
            this.errorMessage = message;
            this.submitted = false;
        },

        handlePaymentToken(pmToken) {
            this.paymentInfo.cardToken = pmToken;
            this.paymentInfo.paymentMethod = 'card';
            this.processPayment();
        },

        async handleExpressPayment(ev) {
            if (this.submitted) { ev.complete('fail'); return; } // a charge is already in flight
            try {
                this.submitted = true;
                this.correlationId = crypto.randomUUID();
                this.paymentError = false;
                this.paymentInfo.cardToken = ev.tokenId;
                this.paymentInfo.cardDetails = {
                    number: `XXXXXXXXXXXX${ev.card.last4}`,
                    expiration_month: ev.card.exp_month,
                    expiration_year: ev.card.exp_year,
                    cardBin: '',
                    cardBrand: ev.card.brand,
                    cardLast4: ev.card.last4,
                };
                this.paymentInfo.cardLast4 = ev.card.last4;
                this.paymentInfo.cardBrand = ev.card.brand;
                this.paymentInfo.paymentMethod = ev.methodName === 'apple-pay' ? 'apple_pay' : 'google_pay';
                if (ev.payerName && !this.fullName) {
                    this.fullName = ev.payerName;
                    const nameParts = ev.payerName.split(' ');
                    this.paymentInfo.first_name = nameParts[0] || '';
                    this.paymentInfo.last_name = nameParts.slice(1).join(' ') || '';
                }
                if (ev.payerEmail && !this.paymentInfo.email) {
                    this.paymentInfo.email = ev.payerEmail;
                }
                await this.processPayment();
                ev.complete('success');
            } catch (error) {
                console.error('[Checkout] Express payment error:', error);
                ev.complete('fail');
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Payment failed. Please try again.';
                this.submitted = false;
            }
        },

        prefillFromUserData() {
            const shipping = this.$store.getters.shipping;
            if (shipping) {
                if (!this.customerInfo.addressLine1 && shipping.address_line_1) this.customerInfo.addressLine1 = shipping.address_line_1;
                if (!this.customerInfo.addressLine2 && shipping.address_line_2) this.customerInfo.addressLine2 = shipping.address_line_2;
                if (!this.customerInfo.city && shipping.city) this.customerInfo.city = shipping.city;
                if (!this.customerInfo.state && shipping.state) this.customerInfo.state = shipping.state;
                if (!this.customerInfo.zip && shipping.zip) this.customerInfo.zip = shipping.zip;
            }
        },

        changePaymentTerms(value) {
            this.paymentInfo.payment_terms = value;
            // Re-report the cart on every term change. Without this add_to_cart only
            // ever described the term in the URL, so a switch to 6 months went unreported.
            this.fireAddToCart();
        },

        // event_value is displayTotal, the same number the page prints as "Due today",
        // so the event always matches what the shopper is looking at.
        fireAddToCart(product = this.localCartItems.find((item) => !item.is_addon) || this.localCartItems[0]) {
            const term = Number(this.paymentInfo.payment_terms);
            // Nothing can be reported yet: the cart is still being built or the
            // pixel has not loaded. Leave lastTrackedTerm alone, so the fire that
            // happens once the cart lands is not mistaken for a duplicate. Marking
            // the term here loses the event outright for anyone who picks a plan
            // before the product fetch resolves.
            if (!window.tracking || !product) return;
            if (term === this.lastTrackedTerm) return;

            try {
                window.tracking.event('add_to_cart', {
                    funnel_step: 1,
                    event_value: this.displayTotal,
                    currency: 'USD',
                    product_id: product.id,
                    product_name: product.name,
                    plan_id: product.stripe_id,
                    quantity: 1,
                    form: "deals"
                });
                this.lastTrackedTerm = term;
            } catch (error) {
                console.log(error);
            }
        },

        getTermLabel(term) {
            if (term === 1) {
                // Term 1 shows per month
                return '/ mo.';
            } else {
                return `/ mo. (<strong>${term} mo plan</strong>)`;
            }
        },

        getSelectedTermLabel(term) {
            // Label for selected term
            if (term === 1) {
                return '/ mo.';
            } else {
                return `${term} month supply`;
            }
        },

        getSelectedTermRightLabel(term) {
            // Right side label for selected term at top
            if (term === 1) {
                return 'Recurring';
            } else {
                return 'One Time Payment';
            }
        },

        getTermSubLabel(term) {
            if (term === 1) {
                return 'Recurring';
            }
            return `$${this.getTotalPrice(term).toFixed(2)} today`;
        },

        getTermMonthlyPrice(term) {
            return this.getTotalPrice(term) / term;
        },

        continueFromStep17() {
            this.active_el = 3;
        },
        getMedicationDetails() {
            if (this.selectedMedication === 'tirzepatide') {
                return {
                    name: 'Tirzepatide',
                    subtitle: 'COMPOUNDED W/ B6',
                    image: require('@/assets/images/Tirzepatide-Vial_1.webp'),
                    straightImage: require('@/assets/images/Tirz_straight.webp'),
                    type: 'Subcutaneous Injection',
                    description: 'The most popular, GLP-2 weight loss program that works on two Glucagon receptor.'
                };
            } else {
                return {
                    name: 'Semaglutide',
                    subtitle: 'COMPOUNDED W/ B12',
                    image: require('@/assets/images/Semaglutide-Vial_1.webp'),
                    straightImage: require('@/assets/images/Sema_straight.webp'),
                    type: 'Subcutaneous Injection',
                    description: 'The original, GLP-1 weight loss program that works on one Glucagon receptor.'
                };
            }
        },

        async loadPlans() {
            try {
                const productId = this.cartItems?.[0]?.id;
                if (!productId) return;
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                    params: { isPromo: true, productId }
                });
                if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                    const plans = {};
                    response.data.plans.forEach((plan) => {
                        if (plan && plan.terms != null && plan.price != null) {
                            plans[Number(plan.terms)] = { id: plan.id, price: Number(plan.price) };
                        }
                    });
                    this.apiPlans = plans;
                }
            } catch (error) {
                console.error('Error loading plans:', error);
            }
        },
        getProductPricing() {
            const base = this.selectedMedication === 'semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
            // Merge live plan prices over the env pricing so missing terms keep the fallback
            const pricing = { ...base };
            [1, 3, 6, 12].forEach((term) => {
                if (this.apiPlans[term]) {
                    pricing[term] = this.apiPlans[term].price;
                }
            });
            return pricing;
        },

        getFirstMonthPrice() {
            return this.getProductPricing()[1] || this.getProductPricing()[0];
        },

        getRegularMonthlyPrice() {
            return this.getProductPricing()[1] || this.getProductPricing()[0];
        },

        getTotalPrice(term) {
            return parseFloat(this.getProductPricing()[term].toFixed(2));
        },

        getCurrentPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                return parseFloat(this.getFirstMonthPrice().toFixed(2));
            } else {
                return parseFloat(this.getTotalPrice(this.paymentInfo.payment_terms).toFixed(2));
            }
        },

        getTotalOrderAmount() {
            const basePrice = this.getCurrentPrice();
            const discount = this.paymentInfo.discount || 0;
            return Math.max(0, basePrice - discount);
        },

        formatDollars(n) {
            return Number(Math.floor(n)).toLocaleString('en-US');
        },

        formatPrice(n) {
            return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        getMonthlyPriceForTerm() {
            // Default to 1 month if not set
            const term = this.paymentInfo.payment_terms || 1;
            const totalPrice = this.getTotalPrice(term);
            return totalPrice / term;
        },

        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.deliveryErrorMessage = 'Sorry! Our shipping partners do not deliver to PO Box addresses. Please enter a valid street address to continue with your order.';
                this.showOutOfStockModal = true;
                // Clear the invalid address
                this.customerInfo.addressLine1 = '';
                this.customerInfo.city = '';
                this.customerInfo.state = '';
                this.customerInfo.zip = '';
                return;
            }

            // Check for restricted states (Louisiana and Mississippi)
            if (address.state === 'LA' || address.state === 'MS') {
                const stateName = address.state === 'LA' ? 'Louisiana' : 'Mississippi';
                this.deliveryErrorMessage = `We apologize! We currently do not deliver to ${stateName}. Please update your shipping address to a different state to continue with your order.`;
                this.showOutOfStockModal = true;
                // Clear the invalid address
                this.customerInfo.addressLine1 = '';
                this.customerInfo.city = '';
                this.customerInfo.state = '';
                this.customerInfo.zip = '';
                return;
            }

            this.customerInfo.addressLine1 = address.street;
            this.customerInfo.addressLine2 = address.address_line2 || '';
            this.customerInfo.city = address.city;
            this.customerInfo.state = address.state;
            this.customerInfo.zip = address.zip;
        },

        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },

        blinkAddress() {
            this.addressBlink = true;
            setTimeout(() => { this.addressBlink = false; }, 1500);
        },
        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },

        async getStripeToken() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            // Validate name and email
            if (!this.fullName || !this.fullName.trim() || !this.paymentInfo.email) {
                this.paymentError = true;
                this.errorMessage = "Please enter your name and email.";
                this.submitted = false;
                return false;
            }

            // Validate name format
            if (!this.isValidName(this.fullName)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a valid name (at least 2 characters, letters only).";
                this.fieldErrors.full_name = true;
                this.submitted = false;
                return false;
            }

            // Validate email format
            if (!this.isValidEmail(this.paymentInfo.email)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a valid email address (e.g., example@domain.com).";
                this.fieldErrors.email = true;
                this.submitted = false;
                return false;
            }

            // Split full name into first and last name after validation
            const {
                firstName,
                lastName
            } = this.splitFullName(this.fullName);
            this.paymentInfo.first_name = firstName;
            this.paymentInfo.last_name = lastName;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.blinkAddress();
                this.submitted = false;
                return false;
            }

            // Step 1: Create lead and register user
            const registered = await this.registerUser();
            if (!registered) {
                return false;
            }

            // Step 2: Confirm payment via Payment Element
            await this.$refs.stripePayment.confirmPayment();
        },

        async payWithKlarna() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            // Same pre-payment sequence as the card path in getStripeToken().
            // Klarna used to skip straight to create-payment-intent, which for a
            // new customer means no account and no auth token — the API answers
            // 401 and the global interceptor in main.js redirects to /login
            // instead of opening Klarna.
            if (!this.fullName || !this.fullName.trim() || !this.paymentInfo.email) {
                this.paymentError = true;
                this.errorMessage = "Please enter your name and email.";
                this.submitted = false;
                return;
            }

            if (!this.isValidName(this.fullName)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a valid name (at least 2 characters, letters only).";
                this.fieldErrors.full_name = true;
                this.submitted = false;
                return;
            }

            if (!this.isValidEmail(this.paymentInfo.email)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a valid email address (e.g., example@domain.com).";
                this.fieldErrors.email = true;
                this.submitted = false;
                return;
            }

            // Klarna's billing_details and the payment-intent payload both read
            // these, so the name has to be split before either is built.
            const {
                firstName,
                lastName
            } = this.splitFullName(this.fullName);
            this.paymentInfo.first_name = firstName;
            this.paymentInfo.last_name = lastName;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete shipping address.';
                this.blinkAddress();
                this.submitted = false;
                return;
            }
            if (this.isPOBox(this.customerInfo.addressLine1)) {
                this.paymentError = true;
                this.errorMessage = 'Our shipping partners do not deliver to PO Box addresses.';
                this.submitted = false;
                return;
            }

            // Creates the account and logs them in, which is what supplies the
            // auth token create-payment-intent needs. Also saves the shipping
            // address. Runs after the address checks because it persists it.
            const registered = await this.registerUser();
            if (!registered) {
                return;
            }

            try {
                const billingAddr = this.customerInfo;
                const shippingAddress = {
                    addressLine1: this.customerInfo.addressLine1,
                    addressLine2: this.customerInfo.addressLine2,
                    city: this.customerInfo.city,
                    state: this.customerInfo.state,
                    zip: this.customerInfo.zip,
                };

                // amountInCents already nets out the coupon discount — don't subtract it again.
                const chargeAmount = this.amountInCents;

                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-intent`, {
                    id: this.user.id,
                    amount: chargeAmount,
                    payment_method_types: ['klarna'],
                    user_id: this.user.id,
                    planId: this.selectedPlanId,
                    payment_terms: this.paymentInfo.payment_terms,
                    couponId: this.paymentInfo.couponId,
                    discount: this.paymentInfo.discount,
                    firstName: this.paymentInfo.first_name,
                    lastName: this.paymentInfo.last_name,
                    email: this.paymentInfo.email,
                    cartTotal: this.displayTotal,
                    shippingAddress,
                    billingAddress: {
                        addressLine1: billingAddr.addressLine1,
                        addressLine2: billingAddr.addressLine2,
                        city: billingAddr.city,
                        state: billingAddr.state,
                        zip: billingAddr.zip,
                    },
                    cartItems: this.cartItems,
                    mainProductTotal: this.getTotalOrderAmount(),
                    addonTotal: 0,
                    totalOrderAmount: this.displayTotal,
                    medication: this.selectedMedication || '',
                    drug_mode: this.paymentInfo.drug_mode || '',
                }, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                const { clientSecret } = response.data;
                const currentUrl = window.location.origin;
                const returnUrl = `${currentUrl}${this.$route.path}/klarna-return`;

                // Snapshot the cart BEFORE redirecting to Klarna so KlarnaReturn.vue — a fresh
                // page load after the redirect — can send cartItems on /api/confirm-klarna-payment
                // ([{ id: productObjectId, quantity, price }]). Keyed to this payment intent so a
                // stale snapshot never attaches to another checkout that shares KlarnaReturn.vue.
                // Mirrors checkoutCallCenter.vue.
                try {
                    const klarnaMainItem = (this.cartItems || []).find((i) => i && i.is_addon === false) || (this.cartItems || [])[0] || {};
                    const snapshotItems = [{
                        id: klarnaMainItem.id,
                        quantity: 1,
                        price: Number((chargeAmount / 100).toFixed(2)),
                    }];
                    sessionStorage.setItem('pending_klarna_cart', JSON.stringify({
                        payment_intent_id: clientSecret.split('_secret')[0],
                        items: snapshotItems,
                    }));
                } catch (e) { /* sessionStorage unavailable — confirm falls back to paymentIntentId only */ }

                // Same reason the cart is snapshotted: this page never runs again after
                // the redirect, so it can't fire its own `purchase`. KlarnaReturn.vue
                // fires this once the server confirms the payment.
                const klarnaMainProduct = this.cartItems.find(item => !item.is_addon) || this.cartItems[0];
                stashKlarnaPurchase(clientSecret.split('_secret')[0], {
                    funnel_step: 2,
                    event_value: Number((chargeAmount / 100).toFixed(2)),
                    product_id: klarnaMainProduct?.id,
                    product_name: klarnaMainProduct?.name,
                    plan_id: klarnaMainProduct?.stripe_id,
                    quantity: 1,
                    coupon: this.paymentInfo.couponCode || undefined,
                    form: "deals"
                });

                // Klarna leaves the site, so KlarnaReturn.vue makes the offer instead.
                // Hand it the charge context before the redirect takes this page away.
                this.stashFastTrackOffer(clientSecret.split('_secret')[0], {
                    userId: this.user.id,
                    paymentMethod: 'klarna',
                    paymentTerms: this.paymentInfo.payment_terms,
                    firstName: this.paymentInfo.first_name,
                    lastName: this.paymentInfo.last_name,
                    email: this.paymentInfo.email,
                    shippingAddress,
                    billingAddress: billingAddr,
                    trackingSessionId: window.trackingSessionId || null,
                    ipAddress: this.ip_address
                });

                const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            name: `${this.paymentInfo.first_name} ${this.paymentInfo.last_name}`,
                            email: this.paymentInfo.email,
                            address: {
                                line1: billingAddr.addressLine1,
                                line2: billingAddr.addressLine2 || '',
                                city: billingAddr.city,
                                state: billingAddr.state,
                                postal_code: billingAddr.zip,
                                country: 'US',
                            },
                        },
                    },
                    return_url: returnUrl,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Klarna payment failed. Please try again.';
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Failed to initiate Klarna payment. Please try again.';
                this.submitted = false;
            }
        },

        async processPayment() {
            try {
                this.submitted = true;
                this.paymentError = false;
                this.paymentInfo.user_id = this.user.id;
                this.paymentInfo.id = this.user.id;
                this.paymentInfo.medication = this.selectedMedication;
                this.paymentInfo.cartItems = this.cartItems;
                this.paymentInfo.planId = this.selectedPlanId;

                const sessionId = window?.trackingSessionId || null;

                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: this.getTotalOrderAmount(),
                    cartTotalNoDiscount: parseFloat((this.getTotalOrderAmount() + (this.paymentInfo.discount || 0)).toFixed(2)),
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    dosage: this.selectedDosage,
                    totalOrderAmount: this.getTotalOrderAmount(),
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: this.ip_address || 'unknown',
                    tracking_session_id: sessionId || 'unknown'
                };
                const response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });
                // paymentData.amount already nets out the coupon discount — don't subtract it again
                let amountCharged = paymentData.amount / 100;

                if (response.data.status === 'success') {
                    // Save purchased products to localStorage
                    const purchasedItems = this.cartItems.map(item => ({
                        name: item.name,
                        price: amountCharged.toFixed(2)
                    }));
                    localStorage.setItem('productsPurchased', JSON.stringify(purchasedItems));

                    // Held before the cart is emptied below — the purchase event fires
                    // after that clear and would otherwise report an empty product.
                    const soldProduct = this.cartItems.find(item => !item.is_addon) || this.cartItems[0];

                    await this.$store.dispatch('setPrescriptionPreauths', response.data.prescriptionPreauths);
                    await this.updateAddress();
                    // Clear local cart after successful payment
                    this.localCartItems = [];

                    let transactionIdentifier;
                    try {
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    } catch (e) {
                        console.log(e);
                        transactionIdentifier = `${Date.now()}`;
                    }

                    // Fired only now, on the server's own success — never on the payment
                    // page and never on the button. event_id is what the ad platforms
                    // dedupe on, so a network retry can't book the sale twice.
                    try {
                        if (window.tracking) {
                            window.tracking.event('purchase', {
                                funnel_step: 2,
                                event_value: amountCharged,
                                currency: 'USD',
                                transaction_id: transactionIdentifier,
                                order_id: response.data.order_id || transactionIdentifier,
                                event_id: crypto.randomUUID(),
                                product_id: soldProduct?.id,
                                product_name: soldProduct?.name,
                                plan_id: soldProduct?.stripe_id,
                                quantity: 1,
                                coupon: this.paymentInfo.couponCode || undefined,
                                form: "deals"
                            });
                        }
                    } catch (error) {
                        console.log('Purchase tracking error:', error);
                    }

                    // Offer priority review on top of the confirmed order, then leave.
                    // With no add-on to offer this hands straight through to pushToRoute.
                    this.offerFastTrackThen({
                        userId: this.user.id,
                        paymentMethod: this.paymentInfo.paymentMethod || 'card',
                        paymentTerms: this.paymentInfo.payment_terms,
                        firstName: this.paymentInfo.first_name,
                        lastName: this.paymentInfo.last_name,
                        email: this.paymentInfo.email,
                        shippingAddress: this.customerInfo,
                        billingAddress: this.customerInfo,
                        trackingSessionId: sessionId,
                        ipAddress: this.ip_address
                    }, () => this.pushToRoute(amountCharged, transactionIdentifier));
                } else {
                    this.errorMessage = response.data.message || "Payment failed";
                    this.submitted = false;
                    this.paymentError = true;
                     this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || "";
                this.submitted = false;
            }
        },

        pushToRoute(amountCharged, transaction_id) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.terms = String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;
                query.trans_id = transaction_id;
                this.$router.push({
                    name: 'collectPhoneAndBMI',
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    name: 'collectPhoneAndBMI'
                });
            }
        }
    },

    watch: {
        paymentError(val) {
            if (val) {
                clearTimeout(this._errorTimeout);
                this._errorTimeout = setTimeout(() => { this.paymentError = false; }, 10000);
            }
        },
        active_el() {
            // Wait for DOM update, then scroll to question
            this.$nextTick(() => {
                const questionDiv = document.querySelector('.step_forminfo_div, .quizquestiondiv2-copy, .quizquestiondiv2, .question-div-2, .glpquiz_div, .step2_div', 'step4_div', 'step5_div', 'step6_div');
                if (questionDiv) {
                    const header = document.querySelector('.section-fixed-prognav');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = 20; // Additional padding from header

                    const elementPosition = questionDiv.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'auto'
                    });
                } else {
                    // Fallback to top if no question div found
                    window.scrollTo(0, 0);
                }
            });
        },

        fullName() {
            this.clearFieldError('full_name');
        },
        'paymentInfo.email'() {
            this.clearFieldError('email');
        }
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
    }
}
</script>

<style scoped>
/* Price loading skeleton — hides env fallback price until live promo price loads */
.price-amt {
    display: inline-block;
}
.price-loading {
    color: transparent !important;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    min-width: 3ch;
}
.price-loading::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #e9e9e9 25%, #f5f5f5 50%, #e9e9e9 75%);
    background-size: 200% 100%;
    animation: price-shimmer 1.1s ease-in-out infinite;
}
@keyframes price-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* Order breakdown under the Due Today bar. Colours are inherited on purpose —
   these checkouts render on both the light and the dark shell. */
.ft-sum-breakdown {
    margin: 14px 0 22px;
}

.ft-sum-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    padding: 5px 0;
    font-size: 14px;
    line-height: 1.4;
}

.ft-sum-label {
    opacity: 0.75;
}

.ft-sum-value {
    display: inline-block;
    font-weight: 500;
    text-align: right;
    white-space: nowrap;
}

.ft-sum-total {
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid rgba(128, 128, 128, 0.35);
    font-size: 17px;
}

.ft-sum-total .ft-sum-label {
    opacity: 1;
    font-weight: 700;
}

.ft-sum-total .ft-sum-value {
    font-weight: 700;
}

@media screen and (max-width: 479px) {
    .ft-sum-row {
        font-size: 13px;
    }

    .ft-sum-total {
        font-size: 16px;
    }
}

.hideOnDesk {
    display: none;
}

.flow-step1-headers {
    margin-bottom: 15px;
}

.flow-inclusions-header {
    margin-bottom: 25px;
    justify-content: center;
    display: flex;
    line-height: 0px;
}

.continue-everything {
    margin-top: 25px;
}

.checkout_checkbox-selected {
    background-color: var(--light-blue);
}

.body_flow.page {
    min-height: 100vh !important;
    height: auto !important;
}

.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.enroll-checkbox-field.field-error {
    border: 2px solid #dc3545;
    border-radius: 4px;
    padding: 8px;
    background-color: rgba(220, 53, 69, 0.05);
}

.link-block-30.field-error {
    border: 2px solid #dc3545 !important;
    background-color: rgba(220, 53, 69, 0.05) !important;
}

input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.w-input.field-error,
.w-select.field-error {
    border: 2px solid #dc3545 !important;
}

.loading-overlay2 {
    position: fixed;
    inset: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.plan-radio {
    cursor: pointer;
    padding: 15px;
    border: 2px solid #ddd;
    border-radius: 8px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
}

.plan-radio.selected {
    border-color: #00c042;
    background-color: #f0fff4;
}

.plan-radio:hover {
    border-color: #00c042;
}

@media screen and (max-width: 991px) {
    .section-fixed-prognav {
        position: relative !important;
        z-index: 99999 !important;
        background-color: white !important;
        /* ADJUST THIS VALUE to change spacing below header (0-50px) */
        margin-bottom: 30px !important;
        padding-bottom: 0 !important;
    }

    .section_checkout-flow {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .flow_wrap {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .glpquiz_div {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .quiz_herodiv {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

@media screen and (max-width: 375px) {

    .quiz_heroviddiv,
    .background-video-10 {
        height: 430px;
    }

    .flex-input-div.dob {
        margin-bottom: 1px;
    }

    .div-block-2251 {
        margin-top: 0px;
    }

    .text-block-1686 {
        font-size: 12px;
    }
}

@media screen and (max-width: 490px) {
    .div-block-2251 {
        margin-top: 5px;
    }

    .flow-inclusions-header {
        font-size: 26px;
    }
}

@media screen and (max-width: 479px) {
    .image-651 {
        width: 16px;
    }

    .express-checkout-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        padding: 16px;
        align-items: stretch;
    }

    .klarna-btn {
        flex-direction: column;
        padding: 4px 6px;
        gap: 2px;
        height: 48px;
        margin-top: 0;
    }

    .klarna-btn:only-child,
    .express-checkout-box.single-option .klarna-btn {
        grid-column: 1 / -1;
    }

    .klarna-btn-text {
        font-size: 11px;
        white-space: nowrap;
    }

    .klarna-logo {
        height: 16px;
    }

    .error-popup {
        min-width: 90%;
    }
}

@media screen and (max-width: 375px) {
    .flow-inclusions-header[data-v-d0ce333a] {
        margin-top: 15px;
        line-height: 33px;
        font-size: 24px;
    }

    .enroll-header {
        flex-direction: column;
        align-items: left;
        padding-bottom: 5px;
        display: flex;
        margin-top: 7px;
        font-size: 32px;
    }

    .form-3-things-div {
        flex-flow: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 5px;
    }

    .formhero-sub {
        text-align: left;
        width: 100%;
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 24px;
    }

    .formhero-sub[data-v-71c43630] {
        text-align: left;
        width: 100%;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
        padding-top: 5px;
    }

    .product-name-2-copy {
        font-size: 16px;
    }

    .section-fixed-prognav[data-v-d0ce333a] {

        margin-bottom: 5px !important;
    }

    .enroll-checkbox-label.w-form-label {
        font-size: 9px;
    }
}

@media screen and (max-width: 350px) {
    .enroll-header {
        font-size: 30px;
    }
    .text-block-1694 {
        font-size: 12px;
    }
    .text-block-1693, .text-span-416, .text-span-417 {
        font-size: 12px;
    }
}

.checkout-checkbox-text {
    font-size: 16px;
}

/* Fix dropdown overflow issue on step 18 */
.flow-payment-div {
    overflow: visible !important;
}

.flow_step3-form-div {
    overflow: visible !important;
}

.checkout-form {
    overflow: visible !important;
}

.flow-dropdown-sum {
    overflow: visible !important;
    position: relative;
}

.dropdown-list-18 {
    position: relative !important;
    z-index: 1000;
}

.flow-payment-div.dropdown-expanded {
    padding-bottom: 450px;
}

.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;

}

.intro-modal-body {
    justify-content: center;
}

.intro-modal-heading {
    font-size: 18px;
    display: flex;
    justify-content: center;
}

.modal-content {
    background-color: #fefefe;
    border-radius: 10px;
    max-width: 468px;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

/* Out of Stock Modal Styles */
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 99999;
}

.out-of-stock-modal {
    background-color: #ffffff;
    border-radius: 12px;
    max-width: 500px;
    width: 90%;
    margin: 0 !important;
    padding: 40px 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: none !important;
}

.out-of-stock-modal .intro-modal-body {
    padding: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.out-of-stock-modal .intro-modal-heading {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    margin: 0;
}

.modal-close-button {
    background-color: #e9ff86;
    color: #000;
    border: none;
    border-radius: 8px;
    padding: 12px 40px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.modal-close-button:hover {
    background-color: #d4e76f;
    transform: translateY(-2px);
}

span.select-icon {
    position: absolute;
    top: 15px;
    left: 5px;
}

.selectwrap {
    position: relative;
}

.checkout-flow-input.thirds {
    padding-left: 30px;
}

.checkout-flow-dropdown {
    padding-left: 25px;
}

.selectwrap input#birth-month {
    width: 100%;
}

.checkout_checkbox-field:active {
    background-color: #ece6ff00;
    border-color: transparent;
}

.tosspan {
    position: absolute;
    font-size: 8px;
    bottom: -3px;
    color: gray;
}
.no-decoration,
.no-decoration:hover,
.no-decoration:focus,
.no-decoration:visited,
.no-decoration:active {
    text-decoration: none !important;
    color: inherit;
}

/* Remove hover/focus/active highlight only when NOT selected */
.checkout_checkbox-field:not(.checkout_checkbox-selected):hover,
.checkout_checkbox-field:not(.checkout_checkbox-selected):focus,
.checkout_checkbox-field:not(.checkout_checkbox-selected):active {
    background-color: var(--white) !important;
    border-color: var(--df-grey) !important;
}

/* Express Checkout */
.express-checkout-section {
    margin-bottom: 16px;
}

.express-checkout-box {
    background: white;
    border: 1px solid #d8dbe0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* NOTE: Uses .pe-divider instead of .divider — webflow CSS defines .divider { width: 1px } which would turn this vertical. */
.pe-divider {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    margin: 12px 0;
    border: none;
    background: transparent;
}

.pe-divider-line {
    flex: 1;
    height: 1px;
    min-width: 0;
    background: #d8dbe0;
}

.pe-divider span {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

.address-highlight :deep(input) {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}

.error-popup {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #fee2e2;
    border: 1px solid #ef4444;
    color: #991b1b;
    padding: 12px 24px;
    border-radius: 8px;
    z-index: 2147483647;
    max-width: 90%;
    text-align: center;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.error-popup-close {
    background: none;
    border: none;
    color: #991b1b;
    font-size: 20px;
    cursor: pointer;
    padding: 0 2px;
    line-height: 1;
    flex-shrink: 0;
}

.klarna-btn {
    width: 100%;
    background: #ffb3c7;
    color: #0b0b0b;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    font-family: inherit;
    height: 48px;
}

.klarna-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 179, 199, 0.5);
}

.klarna-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.klarna-btn-text {
    font-size: 16px;
    font-weight: 600;
}

.klarna-logo {
    height: 18px;
    width: auto;
}

</style>
